var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-basetable',{attrs:{"count":_vm.count,"page":_vm.page,"rows":_vm.rows,"data":_vm.filter,"loading":_vm.loading,"showRefresh":!_vm.local,"rowBind":_vm.rowBind},on:{"refresh":_vm.clickRefresh,"click":function (row, index) { return this$1.$emit('click', row, index); }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_vm._t("default",null,{"row":row,"index":index})]}},{key:"extra",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_vm._t("extra",null,{"row":row,"index":index})]}}],null,true)},[_c('template',{slot:"header"},[_vm._t("header")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }